import React, { useState } from 'react';
import { LeafIcon, MailIcon, LockIcon, UserIcon, ArrowRightIcon } from 'lucide-react';
interface AuthScreenProps {
  authMode: 'login' | 'signup';
  setAuthMode: (mode: 'login' | 'signup') => void;
  onLogin: (email: string) => void;
  onSignup: (firstName: string, lastName: string, email: string) => void;
}
export function AuthScreen({
  authMode,
  setAuthMode,
  onLogin,
  onSignup
}: AuthScreenProps) {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (authMode === 'signup') {
      if (!firstName || !email || !password) return;
      onSignup(firstName, lastName, email);
    } else {
      if (!email || !password) return;
      onLogin(email);
    }
  };
  return <div className="flex flex-col min-h-screen bg-bg-main animate-fade-in relative overflow-hidden" data-id="element-42">
      {/* Decorative Background Elements */}
      <div className="absolute -top-32 -right-32 w-[300px] h-[300px] bg-sage-light/20 rounded-full blur-3xl pointer-events-none" data-id="element-43"></div>
      <div className="absolute top-1/2 -left-32 w-[250px] h-[250px] bg-gold-light/20 rounded-full blur-3xl pointer-events-none" data-id="element-44"></div>

      <div className="flex-1 flex flex-col justify-center px-6 py-12 z-10" data-id="element-45">
        <div className="flex justify-center mb-8" data-id="element-46">
          <div className="w-16 h-16 bg-gradient-to-br from-sage-dark to-sage rounded-2xl flex items-center justify-center shadow-lg shadow-sage-dark/20" data-id="element-47">
            <LeafIcon className="w-8 h-8 text-white" data-id="element-48" />
          </div>
        </div>

        <div className="text-center mb-10" data-id="element-49">
          <h1 className="text-3xl font-extrabold text-text-dark mb-2 tracking-tight" data-id="element-50">
            {authMode === 'signup' ? 'Begin Your Reset' : 'Welcome Back'}
          </h1>
          <p className="text-text-mid text-sm" data-id="element-51">
            {authMode === 'signup' ? 'Join The Drainage Code and activate your flow.' : 'Continue your 7-day lymphatic reset journey.'}
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4" data-id="element-52">
          {authMode === 'signup' && <div className="flex gap-4" data-id="element-53">
              <div className="relative flex-1" data-id="element-54">
                <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-55">
                  <UserIcon className="h-5 w-5 text-text-light" data-id="element-56" />
                </div>
                <input type="text" required value={firstName} onChange={e => setFirstName(e.target.value)} className="w-full pl-11 pr-4 py-3.5 bg-white border border-black/5 rounded-2xl text-sm text-text-dark placeholder-text-light focus:outline-none focus:ring-2 focus:ring-sage-dark/20 focus:border-sage-dark transition-all shadow-sm" placeholder="First Name" data-id="element-57" />
              </div>
              <div className="relative flex-1" data-id="element-58">
                <input type="text" value={lastName} onChange={e => setLastName(e.target.value)} className="w-full px-4 py-3.5 bg-white border border-black/5 rounded-2xl text-sm text-text-dark placeholder-text-light focus:outline-none focus:ring-2 focus:ring-sage-dark/20 focus:border-sage-dark transition-all shadow-sm" placeholder="Last Name" data-id="element-59" />
              </div>
            </div>}

          <div className="relative" data-id="element-60">
            <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-61">
              <MailIcon className="h-5 w-5 text-text-light" data-id="element-62" />
            </div>
            <input type="email" required value={email} onChange={e => setEmail(e.target.value)} className="w-full pl-11 pr-4 py-3.5 bg-white border border-black/5 rounded-2xl text-sm text-text-dark placeholder-text-light focus:outline-none focus:ring-2 focus:ring-sage-dark/20 focus:border-sage-dark transition-all shadow-sm" placeholder="Email Address" data-id="element-63" />
          </div>

          <div className="relative" data-id="element-64">
            <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-65">
              <LockIcon className="h-5 w-5 text-text-light" data-id="element-66" />
            </div>
            <input type="password" required value={password} onChange={e => setPassword(e.target.value)} className="w-full pl-11 pr-4 py-3.5 bg-white border border-black/5 rounded-2xl text-sm text-text-dark placeholder-text-light focus:outline-none focus:ring-2 focus:ring-sage-dark/20 focus:border-sage-dark transition-all shadow-sm" placeholder="Password" data-id="element-67" />
          </div>

          <button type="submit" className="w-full mt-6 bg-gradient-to-r from-sage-dark to-sage text-white font-bold py-4 rounded-2xl shadow-lg shadow-sage-dark/20 flex items-center justify-center gap-2 transition-transform active:scale-[0.98]" data-id="element-68">
            {authMode === 'signup' ? 'Create Account' : 'Log In'}
            <ArrowRightIcon className="w-5 h-5" data-id="element-69" />
          </button>
        </form>

        <div className="mt-8 text-center" data-id="element-70">
          <p className="text-sm text-text-mid" data-id="element-71">
            {authMode === 'signup' ? 'Already have an account?' : "Don't have an account?"}{' '}
            <button onClick={() => setAuthMode(authMode === 'signup' ? 'login' : 'signup')} className="text-sage-dark font-bold hover:underline focus:outline-none" data-id="element-72">
              {authMode === 'signup' ? 'Log In' : 'Sign Up'}
            </button>
          </p>
        </div>
      </div>
    </div>;
}